<template lang="pug">
v-col.pa-0#Inicio(v-if='Inicio')
    //-para PC
    v-container(fluid ).d-none.d-md-block.colorMD.pa-0
        v-app-bar(color='transparent'   dark flat  height='130px' absolute style='z-index:1000' )
            v-btn(color='transparent' height='180px' width='180px' elevation='0').cajaLogo
                v-img(:src='Inicio.logo' height='100px' width='100px')
            v-spacer
                span.correoElectronico {{Inicio.correoElectronico}}
            v-btn(:href='Inicio.enlaceWhatsapp' target='_blank' elevation='0' icon='' tile=''  ).whatsapp
                v-img(:src='Inicio.logowhatsapp' heigth='10px' width='50px' contain)        
                    v-row.mt-12
                    v-row.mt-12
                    v-row.mt-12
                    v-row.mt-12
                    v-row.mt-12
                    v-row.mt-12
                    v-row.mt-12
                    v-row.mt-12
                    v-row.justify-center.align-end.mt-12
                        template( v-for='{imagenRed, enlace}, i of Pie_de_pagina.redes')
                            v-btn( icon tile  :href='enlace' target='_blank' ).mx-5.elevation-0
                                v-img(:src='imagenRed' heigth='9px' width='40'  contain)
       
        v-row.justify-center.align-center
            video( :src='Contenido.video_encabezado' width='100%' height='98%' playsinline autoplay muted loop ) 

        .encabezadoInferior
            ul.flex-container
                img(:src='Inicio.imagen' alt='Janna' height='700%' style='z-index:1000'  ).imagenPrincipal
                v-col(cols=12 md=8).mt-6
                    p.align-center.text-justify.descripcion {{Inicio.descripcion1}}
                    p.align-center.text-justify.descripcion {{Inicio.descripcion2}}
                    p.align-center.text-justify.descripcion {{Inicio.descripcion3}}
                    p.font-weight-bold.align-center.text-justify.descripcion {{Inicio.descripcion4}}
   
    //-para Movil
    v-container(fluid v-if='Inicio').pa-0.d-md-none.colorcontainermovil
        v-row.align-center.justify-center
            v-col(cols=12)
                v-img(:src='Inicio.logo' height='69px' contain).mt-10
        //-video
        v-col(cols=12 md=6)
            v-row.justify-center.align-center.pa-0.d-md-none  
                v-img(contain).pa-0
                    video( contain :src='Contenido.video_encabezado' width='100%' autoplay muted playsinline loop ).pa-0
            //-reddes
            v-row.align-center.justify-center.my-6
                template( v-for='{imagenRed,enlace}, i of Pie_de_pagina.redes').align-center.text-center
                    v-btn(elevation='0' icon='' tile='' :href='enlace' target='_blank' ).mx-1
                        v-img(:src='imagenRed' heigth='10px' width='40px' contain)
            //-boton BEHANCE
            v-row.justify-center.align-center
                v-btn( target='_blank' :href='Inicio.enlaceWhatsapp'  style=' color:var(--primary)' large   outlined rounded ).mt-3
                    span.ml-2 CONVERSEMOS |  😄
                   
    //-texto
    .encabezadoInferiormovil.d-md-none       
        v-container
            v-row.justify-center.align-center
                v-img(:src='Inicio.imagen' alt='Janna' height='140px'  contain ).imagenJannaMovil.mb-8

                v-col(cols=10 ).mt-12
                        p.mt-12.align-center.text-justify {{Inicio.descripcion1}}
                        p.align-center.text-justify {{Inicio.descripcion2}}
                        p.align-center.text-justify {{Inicio.descripcion3}}
                v-row.justify-center.align-center
                    p.font-weight-bold {{Inicio.descripcion4}}
                        
          

</template>
<script>
export default {
    data:()=>({
        
        drawer: false,
        group: null,
      
    }),
    watch: {
      group () {
        this.drawer = false
      },
    },
}
</script>
<style lang="sass" scoped>
.imagenJannaMovil 
    position: absolute
    bottom: 83%
    right: 25%
.posicion
    right: 14vh

.encabezadoInferiormovil 
     
    height: 640px
    background-color: #ffffff
    position: relative
    // .flex-container
    //     position: absolute
    //     top: 50%
    //     left: 50%
    //     width: 80%
    //     height: 70px 
    //     margin-top: -35px 
    //     margin-left: -40% 
    //     text-align: center
    //     list-style: none
    //     display: flex
    //     align-items: center
    //     justify-content: center
    //     z-index: 1
.colorcontainermovil
    background-color: var(--secondary)
    height: 550px
.whatsapp
    position: absolute
    top:35%
    right:14vh
.menu
    position: absolute
    top:33%
    right:11%
.correoElectronico
    position: absolute
    top: 40%
    right: 11%
    font-size: 18px
.cajaLogo
    position: absolute
    top: 20%
    left: 45%
    width: 80%
    height: 70px 
    margin-top: -35px 
    margin-left: -40% 
    text-align: center
    display: flex
    align-items: center
    justify-content: center

.redSocial
    min-width: 0
    background-color: #000000
    padding: 10px
    width: 20px
    border-radius: 10px
.columnaIconos
    position: relative
    top: 4vh
    left: 70vh
.descripcion
    font-size: 17px
    font-weight: 100
    width: 600px
.imagenPrincipal 
    position: relative
    bottom: 95%
    right: 5%
    
    
    
.textoResaltado
    position: relative
    bottom: 40px
    left: 32vh
    font-size: 70px
    font-weight: 700
    color: var(--primary)
.textoBlanco
    position: relative
    bottom: 60px
    left: 33vh
    
    font-size: 40px
    color: #ffffff

.textoResaltadomovil
    position: relative
    font-size: 35px
    color: var(--primary)
.textoBlancomovil
    position: relative
    font-size: 15px
    color: #ffffff

.space-around
    justify-content: space-around
.colorMD
    height: 110vh
    .encabezadoSuperior
        
        background-color: var(--secondary)
        display: flex
        flex-direction: row
        align-items: center
        justify-content: center
        background-size: cover
    .encabezadoInferior
        height: 356px
        background-color: #ffffff
        position: relative
        .flex-container
            position: absolute
            top: 50%
            left: 50%
            
            height: 70px 
            margin-top: -35px 
            margin-left: -40% 
            text-align: center
            list-style: none
            display: flex
            align-items: center
            justify-content: center
            z-index: 1
</style>
